import { jsx as _jsx } from "react/jsx-runtime";
// <reference path="./index.d.ts" />
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
sessionStorage.clear();
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(_jsx(React.StrictMode, { children: _jsx(App, {}) }));
